import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useKeycloak } from '../context/KeycloakContext';
import { useAuth } from '../context/AuthContext';
import env from '../config/env';
import LoadingSpinner from './LoadingSpinner';
import { isRouteForbidden } from './routeGuards';
import { useOptionalPermissions } from '../context/permissionContextCore';

const ProtectedRoute = () => {
    const useKeycloakAuth = env.useKeycloakAuth;
    const { keycloak, isAuthenticated: isKeycloakAuthenticated, isLoading: isKeycloakLoading } = useKeycloak();
    const { isAuthenticated: isCustomAuthenticated } = useAuth();
    const location = useLocation();
    // Nessun valore da leggere: iscrive la guardia ai cambi di permessi, cosi' dopo un
    // refresh() che toglie l'accesso alla pagina aperta la rotta si rivaluta e rimanda in
    // dashboard. `isRouteForbidden` resta pura e legge RoleService.
    useOptionalPermissions();

    // If environment config is still loading, wait without showing anything
    if (env.isLoading) {
        return null;
    }

    // For Keycloak authentication
    if (useKeycloakAuth) {
        // If still loading, show loading spinner
        if (isKeycloakLoading) {
            return <LoadingSpinner />;
        }

        // If not authenticated, redirect to Keycloak login
        if (!isKeycloakAuthenticated) {
            keycloak.login();
            return null;
        }

        if (isRouteForbidden(location.pathname)) {
            return <Navigate to="/dashboard" replace />;
        }

        // If authenticated and has access, render the protected content
        return <Outlet />;
    }

    // For custom authentication
    const isAuthenticated = isCustomAuthenticated;

    if (isRouteForbidden(location.pathname)) {
        return <Navigate to="/dashboard" replace />;
    }

    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRoute; 